import { get, sync } from 'vuex-pathify';
export default {
  computed: {
    zoom: sync('map/zoom'),
    isSidebarVisible: get('map/isSidebarVisible'),
  },
  methods: {
    defaultMvtSourceLoader(tile, layerId) {
      tile.setLoader(async (extent, resolution, featureProjection) => {
        const [z, x, y] = tile.tileCoord;
        const r = await fetch(`${process.env.VUE_APP_HOST}/vtiles/${layerId}/${z}/${x}/${y}.pbf`);
        const features = tile.getFormat().readFeatures(await r.arrayBuffer(), {
          extent,
          featureProjection,
        });
        tile.setFeatures(features);
      });
    },
    defaultOffersCartogramGeojsonLoader(vectorSource, geojson) {
      vectorSource.addFeatures(
        vectorSource.getFormat().readFeatures(geojson, {
          dataProjection: geojson.crs.properties.name,
          featureProjection: this.$_config.mapDataCoordinateSystem.epsg,
        })
      );
    },
    getLayerBy(value, { by = 'id', group } = {}) {
      return group
        ? this.map
            .getLayers()
            ?.getArray()
            ?.find(g => g.get('name') == group)
            .getLayersArray()
            .find(layer => layer.get(by) == value)
        : this.map
            .getLayers()
            .getArray()
            .find(layer => layer.get(by) == value);
    },
    getInteractionByName(name) {
      return this.map
        .getInteractions()
        .getArray()
        .find(interaction => interaction.get('name') === name);
    },
    refreshLayerSource(value, { by = 'id', group } = {}) {
      const layer = this.getLayerBy(value, { by, group });
      if (layer) {
        layer.getSource().changed();
      }
    },
    fitView({ value, options = { duration: 250 } } = {}) {
      options.padding = options.padding || [0, this.isSidebarVisible ? 467 : 0, 0, 0];
      this.map.getView().fit(value, options);
      const { minZoom } = options;
      if (minZoom && minZoom > this.map.getView().getZoom()) {
        this.map.getView().setZoom(minZoom);
      }
    },
    setView({ zoom = 18, center, options = { duration: 250 } } = {}) {
      this.map.getView().animate({ zoom, center, ...options });
    },
    zoomView(value, delta = 1) {
      const view = this.map.getView();
      const zoom = value ? view.getZoom() + delta : view.getZoom() - delta;
      if (view.getMinZoom() > zoom) {
        return;
      }
      this.setView({ zoom });
    },
    resetView() {
      this.$router.push({ name: 'main', params: { lid: this.offersLayersIds[this.currentLng]?.greenfields } });
    },
    setZoom(map) {
      this.zoom = map.getView().getZoom();
    },
  },
  mounted() {
    this.$root.$off('refreshLayerSource');
    this.$root.$on('refreshLayerSource', this.refreshLayerSource);
  },
};
